import React from 'react'
import {WKCurrencyItemForIndex} from '../../components/wk';
import { MainItemListCardView } from './index'

class MainFeedConfiguration extends React.Component {

    render(){
        const {data} = this.props;
        const wrapStyle = {
            position: 'relative',
            overflow: 'hidden',
            backgroundColor: '#fff',
            paddingBottom: data.module_style ==='3' && 5,
        }
        return (
            <div className="FeedConfiguration">
                <div className="feedTitle">{data.name}</div>
                {data.module_style !=='3' &&
                    data.contents.map((item, index) => {
                        switch (item.style_name) {
                            case 'advertise' :
                                return (
                                    <div onClick={() => window.location = item.cover_urls[0].advertisement_url_1}
                                         key={index} style={{width: '100%'}} style={{backgroundColor :'#fbfafe'}}>
                                        <img src={item.cover_urls[0].cover_url} alt="" width="100%"/>
                                    </div>
                                )
                            case 'double_advertise' :
                                let doubleBannerStyle = {
                                    paddingTop:  data.contents[index - 1] && data.contents[index - 1].style_name && data.contents[index - 1].style_name === 'advertise' ?   10 : 0,
                                    paddingBottom: data.contents[index + 1] && data.contents[index + 1].style_name && data.contents[index + 1].style_name === 'advertise' || data.contents[index+1] == data.contents.length ?  10 : 0,
                                }

                                return(
                                    <div className="index-Feed-doubleBanner" style={doubleBannerStyle} key={index}>
                                        {item.cover_urls.map((v) => {
                                            return (
                                                <div className='Feed-doubleBanner-item' key={v.cover_url} onClick={() => window.location = v.advertisement_url_1}>
                                                    <img src={v.cover_url} alt=""/>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )
                            default:
                                const isHiddenBorder= data.contents[index - 1] && data.contents[index - 1].style_name && data.contents[index - 1].style_name === 'double_advertise' ?  true : false;
                                return(
                                    <div className="feed-list-item" key={index} >
                                        <WKCurrencyItemForIndex HiddenBorder={isHiddenBorder} content={item} key={item.id} inviterId={item.inviter_id}/>
                                    </div>
                                )
                             }
                        })
                }
                <div style={wrapStyle}>
                    {data.module_style ==='3' &&
                        data.contents.map((item, index) => {
                            return (
                                <MainItemListCardView content={item} key={index}/>

                            )
                        })
                    }

                </div>
            </div>
        )
    }
}

export default MainFeedConfiguration


// WEBPACK FOOTER //
// ./src/components/main/MainFeedConfiguration.js